"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _utils = require("./utils");

var colors = {
  red: '#de3919',
  blue: '#002c5f',
  lightBlue: '#88c1e4',
  gray: '#4e4e4e',
  lightGray: '#ada398',
  green: '#3daf4e',
  darkGray: '#393939',
  blueAlt: '#4997b7',
  orange: '#ef7d4a',
  white: '#ffffff'
};

var makeTintUsing = function makeTintUsing(colors, colorFn) {
  return Object.keys(colors).reduce(function (tints, c) {
    return tints[c] = new Array(10).fill(0).reduce(function (cols, _, i) {
      return cols[100 - 10 * i] = colorFn(colors[c], 5 * i), cols;
    }, {}), tints;
  }, {});
};

var tints = {
  light: (0, _objectSpread2.default)({
    blue: {
      100: '#002c5f',
      90: '#19416f',
      80: '#33567e',
      70: '#4c6b8f',
      60: '#66809f',
      50: '#7f95af',
      40: '#99aabe',
      30: '#b2bfcf',
      20: '#ccd4df',
      10: '#e5e9ef'
    },
    lightBlue: {
      100: '#88c1e4',
      90: '#94c7e7',
      80: '#9fcde9',
      70: '#abd3ec',
      60: '#b7d9ee',
      50: '#b7d9ee',
      40: '#cfe6f4',
      30: '#dbecf7',
      20: '#e7f2f9',
      10: '#f3f9fc'
    },
    gray: {
      100: '#4e4e4e',
      90: '#5f5f5f',
      80: '#717171',
      70: '#838383',
      60: '#949494',
      50: '#a6a6a6',
      40: '#b8b8b8',
      30: '#cacaca',
      20: '#dbdbdb',
      10: '#ededed'
    },
    lightGray: {
      100: '#ada398',
      90: '#b5aca2',
      80: '#bab5ac',
      70: '#c5beb7',
      60: '#cdc7c1',
      50: '#d6d1cb',
      40: '#dedad5',
      30: '#e6e3e0',
      20: '#eeecea',
      10: '#f7f6f4'
    }
  }, makeTintUsing({
    green: colors.green,
    orange: colors.orange
  }, _utils.lighten)),
  dark: makeTintUsing(colors, _utils.darken)
};
var palette = (0, _objectSpread2.default)({}, colors, {
  colors: colors,
  tints: tints,
  buttonPrimary: colors.blue,
  buttonPrimaryHover: tints.light.blue['80'],
  buttonSecondary: colors.orange,
  buttonSecondaryHover: tints.dark.orange['90'],
  loginButton: colors.red,
  loginHeader: colors.white,
  loginHeaderText: colors.red,
  maintenanceHeader: colors.red,
  navBarBackground: colors.white,
  navBarBoxShadow: '0px 5px 12px 0px rgba(0, 0, 0, 0.25)',
  navBarText: colors.darkGray,
  navBarSelectedTabUnderline: colors.red,
  navBarSelectedTabBackground: 'rgba(0,0,0,0.1)',
  navBarTabSeparator: colors.blue,
  navBarSubtitle: colors.lightGray,
  navBarDividerBG: 'rgba(0,0,0,0)',
  navBarDividerBGC: 'rgba(0,0,0,0)',
  navBarOrgName: colors.blueAlt,
  subTabActiveLine: colors.red,
  subTabInactive: '#F2F2F2',
  text: colors.darkGray
});
var _default = palette;
exports.default = _default;